import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import classNames from 'classnames';
import get from 'lodash-es/get';
import PropTypes from 'prop-types';
import React, { useCallback, Fragment } from 'react';
import { PropTypes as PropTypes$1 } from '@panneau/core';
import { useFieldsManager, useFieldsComponents } from '@panneau/core/contexts';
import { getComponentFromName } from '@panneau/core/utils';
import FormGroup from '@panneau/element-form-group';

var definition = {
  id: 'fields',
  component: 'fields'
};

var _excluded = ["type", "component", "name", "horizontal", "inline", "withoutFormGroup", "isListItem", "siblingFields", "defaultValue", "className", "groupClassName", "labelClassName"],
  _excluded2 = ["id", "component"];
var propTypes = {
  components: PropTypes.object,
  // eslint-disable-line react/forbid-prop-types
  fields: PropTypes$1.fields,
  value: PropTypes.object,
  // eslint-disable-line react/forbid-prop-types
  horizontal: PropTypes.bool,
  isList: PropTypes.bool,
  disabled: PropTypes.bool,
  hideWithoutValue: PropTypes.bool,
  onChange: PropTypes.func,
  className: PropTypes.string
};
var defaultProps = {
  components: null,
  fields: [],
  value: null,
  horizontal: false,
  isList: false,
  disabled: false,
  hideWithoutValue: false,
  onChange: null,
  className: null
};
var _Fields = function Fields(_ref) {
  var providedComponents = _ref.components,
    fields = _ref.fields,
    value = _ref.value,
    fieldsHorizontal = _ref.horizontal,
    isList = _ref.isList,
    hideWithoutValue = _ref.hideWithoutValue,
    disabled = _ref.disabled,
    onChange = _ref.onChange,
    className = _ref.className;
  var fieldsManager = useFieldsManager();
  var contextComponents = useFieldsComponents();
  var components = providedComponents || contextComponents;
  var onFieldChange = useCallback(function (_ref2, newFieldValue) {
    var _ref2$name = _ref2.name,
      name = _ref2$name === void 0 ? null : _ref2$name;
    var newValue = name !== null ? _objectSpread(_objectSpread({}, value), {}, _defineProperty({}, name, newFieldValue)) : _objectSpread(_objectSpread({}, value), newFieldValue);
    if (onChange !== null) {
      onChange(newValue);
    }
  }, [onChange, value]);
  var content = (fields || []).map(function (field, index) {
    var _ref3 = field || {},
      _ref3$type = _ref3.type,
      type = _ref3$type === void 0 ? null : _ref3$type,
      _ref3$component = _ref3.component,
      component = _ref3$component === void 0 ? null : _ref3$component,
      _ref3$name = _ref3.name,
      name = _ref3$name === void 0 ? null : _ref3$name,
      _ref3$horizontal = _ref3.horizontal,
      horizontal = _ref3$horizontal === void 0 ? false : _ref3$horizontal,
      _ref3$inline = _ref3.inline,
      inline = _ref3$inline === void 0 ? false : _ref3$inline,
      _ref3$withoutFormGrou = _ref3.withoutFormGroup,
      withoutFormGroup = _ref3$withoutFormGrou === void 0 ? false : _ref3$withoutFormGrou,
      _ref3$isListItem = _ref3.isListItem,
      isListItem = _ref3$isListItem === void 0 ? isList : _ref3$isListItem,
      _ref3$siblingFields = _ref3.siblingFields,
      siblingFields = _ref3$siblingFields === void 0 ? [] : _ref3$siblingFields,
      _ref3$defaultValue = _ref3.defaultValue,
      defaultValue = _ref3$defaultValue === void 0 ? null : _ref3$defaultValue,
      _ref3$className = _ref3.className,
      fieldClassName = _ref3$className === void 0 ? null : _ref3$className,
      _ref3$groupClassName = _ref3.groupClassName,
      groupClassName = _ref3$groupClassName === void 0 ? null : _ref3$groupClassName,
      _ref3$labelClassName = _ref3.labelClassName,
      labelClassName = _ref3$labelClassName === void 0 ? null : _ref3$labelClassName,
      fieldProps = _objectWithoutProperties(_ref3, _excluded);
    var fieldDefinition = type !== null ? fieldsManager.getDefinition(type) : null;
    var _ref4 = fieldDefinition || {};
      _ref4.id;
      var _ref4$component = _ref4.component,
      definitionComponent = _ref4$component === void 0 ? null : _ref4$component,
      definitionProps = _objectWithoutProperties(_ref4, _excluded2);
    var FieldComponent = getComponentFromName(component || definitionComponent, components);
    var fieldValue; // To detect if it's truly empty and not null
    if (value !== null && name !== null) {
      fieldValue = get(value, name, null);
    } else if (name === null) {
      fieldValue = value;
    }
    if (name !== null && fieldValue === null && hideWithoutValue) {
      return null;
    }
    if (defaultValue !== null && typeof fieldValue === 'undefined') {
      fieldValue = defaultValue;
    }
    var fieldElement = FieldComponent !== null ? /*#__PURE__*/React.createElement(FieldComponent, Object.assign({}, definitionProps, {
      disabled: disabled === true
    }, fieldProps, {
      name: name,
      value: fieldValue,
      horizontal: horizontal,
      onChange: function onChange(newValue) {
        return onFieldChange(field, newValue);
      },
      className: fieldClassName
    })) : null;
    return /*#__PURE__*/React.createElement(Fragment, {
      key: "field-".concat(name || index, "-").concat(index + 1)
    }, !withoutFormGroup && fieldElement !== null ? /*#__PURE__*/React.createElement(FormGroup, Object.assign({
      key: "field-".concat(name || index)
    }, definitionProps, fieldProps, {
      horizontal: horizontal,
      inline: inline,
      isListItem: isListItem,
      className: classNames([{
        'mb-3': !isListItem
      }, groupClassName]),
      labelClassName: classNames([labelClassName])
    }), fieldElement) : fieldElement, siblingFields !== null && siblingFields.length > 0 ? /*#__PURE__*/React.createElement(_Fields, {
      fields: siblingFields,
      value: value,
      onChange: onChange
    }) : null);
  });
  return /*#__PURE__*/React.createElement("div", {
    className: classNames([_defineProperty({
      fields: true,
      'list-group': isList,
      'list-group-horizontal': fieldsHorizontal
    }, className, className !== null)])
  }, fieldsHorizontal && !isList ? /*#__PURE__*/React.createElement("div", {
    className: classNames({
      'd-inline-flex flex-row': !isList
    })
  }, content) : content);
};
_Fields.propTypes = propTypes;
_Fields.defaultProps = defaultProps;

export { _Fields as default, definition };
